<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-12">
          <h5>Manage ID Cards</h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row mb-3">
          <div class="col-12 col-md-10">
            <div class="row">
              <!-- Select Session -->
              <div class="col-md-4 col-12 mb-2">
                <a-select
                  size="large"
                  v-model="selectedSession"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleSessionChange"
                  :filterOption="false"
                  :defaultValue="currentSession ? currentSession.id : ''"
                >
                  <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                    {{schoolSession.name}}
                    <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                  </a-select-option>
                </a-select>
              </div>
              <!-- Select Class -->
              <div class="col-md-4 col-12 mb-2">
                <a-spin :spinning="classSpinning">
                  <a-select
                    size="large"
                    v-model="selectedClass"
                    placeholder="Select class"
                    optionFilterProp="children"
                    style="width: 100%"
                    @change="handleClassSelect"
                    :filterOption="false"
                    :defaultValue="undefined"
                  >
                    <a-select-option :value="undefined">All Classes</a-select-option>
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                        {{schoolClass.name}}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </div>
              <!-- Select Section -->
              <div class="col-md-4 col-12 mb-2">
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    size="large"
                    v-model="selectedSection"
                    placeholder="Select section"
                    optionFilterProp="children"
                    style="width: 100%"
                    @change="handleSectionChange"
                    :filterOption="false"
                    :defaultValue="undefined"
                    :disabled="!selectedClass"
                  >
                    <a-select-option :value="undefined">All Sections</a-select-option>
                    <template v-for="section in sections">
                      <a-select-option :value="section.id" :key="section.id">
                        {{section.name}}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-2 text-md-right text-left">
            <button
              type="button"
              class="btn btn-dark btn-with-addon"
              @click="idBulkDownload"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-download" />
              </span>
              Bulk Download
            </button>
          </div>

          <div class="col-6 col-md-2 text-right d-none">
            <button
              type="button"
              class="btn btn-primary"
              @click="generateBulk"
            >
              Generate Bulk
            </button>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 pr-md-0">
                <vue-custom-scrollbar class="student-scroll-area">
                  <!-- <div style="height: 85vh; overflow-y: auto;"> -->
                    <div class="text-right mb-3">
                      <a-input-search
                        v-model="search"
                        placeholder="Search Students.."
                        size="large"
                        @search="searchStudents"
                        @change="searchStudents"
                      />
                    </div>
                    <students-list :data="data" :loading="loading" @studentSelected="handleStudentSelection" />
                  <!-- </div> -->
                </vue-custom-scrollbar>
                <div class="pt-3 pr-md-2">
                  <a-pagination
                    :total="meta.total"
                    :pageSize.sync="pageSize"
                    v-model="current"
                    @change="onChange"
                  >
                  </a-pagination>
                </div>
              </div>

              <div class="col-md-8 border-left">
                <div class="mb-4">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <p class="mb-4">ID Card Preview</p>
                    </div>
                    <div class="col-12 col-md-6 text-right" v-if="htmlContent">
                      <button type="button" @click="downloadImage" v-if="htmlContent" class="btn btn-primary btn-sm">Download ID Card</button>
                    </div>
                  </div>
                  <div class="card mb-4">
                    <div class="card-body text-center">
                      <a-spin :spinning="loading">
                        <img :src="htmlContent" v-if="htmlContent" :student="selectedStudent" :template="selectedTemplate" alt="ID Card" class="img-fluid mb-5" style="width: 350px; height: 500px">
                      </a-spin>
                    </div>
                  </div>
                </div>
              </div>

<!--              <div class="col-md-3">-->
<!--                <p>Select Template</p>-->
<!--                <id-card-template :data="templatesData" @templateSelected="handleTemplateSelection"/>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import StudentsList from '@/components/idcard/List/index'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { templatesData } from './templates'
import { debounce, find } from 'lodash'
// import IdCardTemplate from '@/components/idcard/Template/index'
// import IdCardPreview from '@/components/idcard/Preview/index'

export default {
  components: {
    StudentsList,
    // IdCardTemplate,
    // IdCardPreview,
    vueCustomScrollbar,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('idcard', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getStudents()
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  created() {
    this.searchStudents = debounce(this.searchStudents, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      current: 1,
      pageSize: 15,
      search: null,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      selectedStudent: undefined,
      templatesData,
      selectedTemplate: templatesData[0],
      htmlContent: '',
      permissionCheckSpinning: true,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    generateBulk: function() {
      this.loading = true
      this.$http
        .get(`/api/idcard/bulk/student/generate`, {
          params: {
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            session_id: this.selectedSession,
          },
        })
        .then((data) => {
          this.loading = false
          this.data = data.data
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
        })
    },
    idBulkDownload: function() {
      const subdomain = window.location.host.split('.')[0]
      this.loading = true
      this.$http
        .get('/api/idcard/bulk/student/download', {
          params: {
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            session_id: this.selectedSession,
          },
          responseType: 'blob',
        })
        .then((response) => {
          this.loading = false
          const blob = new Blob([response.data], { type: 'application/zip' })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = `idcards_${subdomain}.zip`
          document.body.appendChild(a)
          a.click()

          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
        })
    },
    getStudents: function() {
      this.selectedStudent = null
      this.loading = true
      this.$http.get('/api/student', {
        params: {
          limit: this.pageSize,
          page: this.current,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchStudents: function(e) {
      this.getStudents()
    },
    handleCreated: function() {
      this.getStudents()
    },
    handleStudentSelection: function(student) {
      this.selectedStudent = student
      this.loading = true
      this.$http.get(`/api/idcard/single/student/${student.id}`, { responseType: 'blob' })
        .then((response) => {
          this.htmlContent = URL.createObjectURL(new Blob([response.data]))
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    downloadImage() {
      if (this.htmlContent && this.selectedStudent) {
        const filename = `IDCard_${this.selectedStudent.first_name}_${this.selectedStudent.last_name}_${this.selectedStudent.student_code}.jpg`
        const link = document.createElement('a')
        link.href = this.htmlContent
        link.download = filename
        link.click()
      }
    },
    // handleTemplateSelection: function(template) {
    //   this.selectedTemplate = template
    // },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStudents()
    },
    onChange(current) {
      this.current = current
      this.getStudents()
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
        this.getStudents()
      } else {
        this.getStudents()
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getStudents()
      } else {
        this.selectedSection = undefined
        this.getStudents()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getStudents()
    },
  },
}
</script>
<style lang="scss">
  .student-scroll-area {
    position: relative;
    height: 85vh;
    padding-right: 1rem;
    overflow: auto;
  }
</style>
